var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('v-content',{class:_vm.containerClasses},[(_vm.showAppbar)?_c('app-bar'):_vm._e(),_c('router-view'),(_vm.showFooter)?_c('app-footer'):_vm._e()],1),_c('global-loader'),_c('global-snackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }